import Entity from "../../../class/abstract/Entity";

class StoreRequest extends Entity {
    name = null;
    siren = null;
    company_id = null;
    company_name = null;
    postalCode = null;
    city = null;
    country = null;
    sector = null;
    phone = null;
    email = null;
    manager = null;
	datas = null;
	created_by = null;
	executed_by = null;
	executed_at = null;
	store_id = null;
	creator_name = null;
	partnership_name = null;
	partnership_id = null;

    constructor(datas = {}) {
        super(datas)
        this.setAttributes(datas)
    }

	setAttributes(datas) {
		let keys = Object.keys(this);
		let key = "";
		let i = 0;

		for(i in keys) {
			key = keys[i];

			if (datas[key] !== undefined) {
				// except keys
				let exceptKeys = [];

				if (!exceptKeys.includes(key))
					Reflect.set(this, key, datas[key]);
			}
		}

		this.explodeDatas();
	}

	explodeDatas() {
		if (this.datas === null)
			return;

		let explode = JSON.parse(this.datas);
		if (explode === undefined || explode === null)
			return;

		this.name = explode["name"] !== undefined ? explode["name"] : null;
		this.siren = explode["siren"] !== undefined ? explode["siren"] : null;
		this.company_id = explode["company_id"] !== undefined ? explode["company_id"] : null;
		this.company_name = explode["company_name"] !== undefined ? explode["company_name"] : null;
		this.postalCode = explode["postalCode"] !== undefined ? explode["postalCode"] : null;
		this.city = explode["city"] !== undefined ? explode["city"] : null;
		this.country = explode["country"] !== undefined ? explode["country"] : null;
		this.sector = explode["sector"] !== undefined ? explode["sector"] : null;
		this.phone = explode["phone"] !== undefined ? explode["phone"] : null;
		this.email = explode["email"] !== undefined ? explode["email"] : null;
		this.manager = explode["manager"] !== undefined ? explode["manager"] : null;
	}
}

export default StoreRequest;